var React = require('react');

function DspColor (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15 4.49951H1C0.447715 4.49951 0 4.94723 0 5.49951V7.49951C0 8.0518 0.447715 8.49951 1 8.49951H15C15.5523 8.49951 16 8.0518 16 7.49951V5.49951C16 4.94723 15.5523 4.49951 15 4.49951Z","fill":"#4338CA","key":0}),React.createElement("path",{"d":"M11 14.4983H5C4.44772 14.4983 4 14.946 4 15.4983V17.4983C4 18.0506 4.44772 18.4983 5 18.4983H11C11.5523 18.4983 12 18.0506 12 17.4983V15.4983C12 14.946 11.5523 14.4983 11 14.4983Z","fill":"#A5B4FC","key":1}),React.createElement("path",{"d":"M13 9.5H3C2.44772 9.5 2 9.94772 2 10.5V12.5C2 13.0523 2.44772 13.5 3 13.5H13C13.5523 13.5 14 13.0523 14 12.5V10.5C14 9.94772 13.5523 9.5 13 9.5Z","fill":"#A5B4FC","key":2})]);
}

DspColor.defaultProps = {"width":"16","height":"20","viewBox":"0 0 16 20","fill":"none"};

module.exports = DspColor;

DspColor.default = DspColor;
